import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from '../pages/Home';
import VotacaoPotes from '../pages/Pots';
import Login from '../pages/Login/Login';
import CheckinNfcPage from '../pages/checkin/CheckinNfcPage';
import PageAprove from '../pages/aprove/Aprove';
import PageDashBoard from '../pages/dashbord/Dashboard';
import Estatuto from '../pages/Estatuto';
import ResetPassword from '../pages/ResetPassword';

import { AuthProvider } from '../AuthContext'; 
import { AuthMiddleware } from './AuthMiddleware'; // Importe o AuthMiddleware
import { AuthMiddlewareAdmin } from './AuthMiddlewareAdmin';
import Squad from '../pages/squads/Squad';
import Confrontos from '../pages/Grupo/Confrontos';
import Politicas from '../pages/Politica';
import PlayArrivedPage from '../pages/arrived/PlayArrivedPage';
import PartidasPage from '../pages/game/PartidasPage';
import Inscricao from '../pages/Torneio/PRESENTATIONPAGE';
import PageInscricao from '../pages/Torneio/REGISTRATIONPAGE';
import PageQrCode from '../pages/Torneio/CONFIRMATIONPAGE';
import AdminPlayersPage from '../pages/admJogadores/components/AdminPlayersPage';
import Ranking from '../pages/games/RankingPage';
import AdminJogosPage from '../pages/jogos/AdminJogosPage';
import CadastrarJogoPage from '../pages/jogos/CadastrarJogoPage';
import ListarJogosPage from '../pages/jogos/ListarJogosPage';
import EditarJogoPage from '../pages/jogos/EditarJogoPage';
import EditarJogoDetalhes from '../pages/jogos/EditarJogoDetalhes';
import ClassificacaoPage from '../pages/jogos/torneio/ClassificacaoPage';
import ClassificacaoJogadores from '../pages/jogos/torneio/ClassificacaoJogadores';
import ClassificacaoPageView from '../pages/jogos/torneio/ClassificacaoPageView';
import ClassificacaoJogadoresView from '../pages/jogos/torneio/ClassificacaoJogadoresView';
import ListarJogosPageView from '../pages/jogos/ListarJogosPageView';
import VotarMelhorJogadorPage from '../pages/jogos/torneio/VotarMelhorJogadorPage';
import MelhorJogadorPage from '../pages/jogos/torneio/MelhorJogadorPage';
import ProfilePage from '../pages/Profile/ProfilePage';
import PaymentPage from '../pages/Payments/PaymentPage';
import RegisterPage from '../pages/Register/RegisterPage';
import PeladaPanel from '../pages/Painel/PeladaPanel';
import AvaliacaoPage from '../pages/Avaliacao/AvaliacaoPage';
import ArbitroLogin from '../pages/Arbitro/ArbitroLogin';
import ArbitroPage from '../pages/Arbitro/ArbitroPage';
import { ArbitroMiddleware } from './ArbitroMiddleware';
import { GoleiroMiddleware } from './GoleiroMiddleware';
import { PeladaAtivaRedirect } from './PeladaAtivaRedirect';
import GoleiroPage from '../pages/Goleiro/GoleiroPage';
import FinanceiroPage from '../pages/Financeiro/FinanceiroPage';
import AppPrompts from '../components/AppPrompts';
import NotificacoesMonitor from '../components/NotificacoesMonitor';
import TrocarSenhaObrigatoria from '../components/TrocarSenhaObrigatoria';
import CadastrarUsuarioPage from '../pages/Usuarios/CadastrarUsuarioPage';
import NotificacoesPage from '../pages/Notificacoes/NotificacoesPage';
import PeladasPage from '../pages/Peladas/PeladasPage';
import PeladaEstatisticasPage from '../pages/Peladas/PeladaEstatisticasPage';


const App = () => {
  return (
    <AuthProvider>
      <Router>
        <PeladaAtivaRedirect />
        <TrocarSenhaObrigatoria />
        <AppPrompts />
        <NotificacoesMonitor />
        <Routes>
          {/* Rotas públicas (sem necessidade de autenticação) */}
          <Route path="/" element={<Home />} />
          <Route path="/pagamento/:token" element={<PaymentPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/cadastro" element={<RegisterPage />} />
          <Route path="/arbitro/login" element={<ArbitroLogin />} />
          <Route path="/arbitro" element={<ArbitroMiddleware><ArbitroPage /></ArbitroMiddleware>} />
          <Route path="/goleiro/login" element={<ArbitroLogin papel="goleiro" />} />
          <Route path="/goleiro" element={<GoleiroMiddleware><GoleiroPage /></GoleiroMiddleware>} />
          <Route path="/squad" element={<Squad/>} />
          <Route path="/estatuto" element={<Estatuto />} />
          <Route path="/confrontos" element={<Confrontos />} />
          <Route path="/privacidade" element={<Politicas />} />
          <Route path="/reset-password/:token" element={<ResetPassword/>} />
          <Route path="/inscricao/" element={<Inscricao/>} />
          <Route path="/ranking/" element={<Ranking/>} />
          <Route path="/torneio/" element={<AdminJogosPage/>} />
          <Route path="/cadastrar-jogo/" element={<CadastrarJogoPage/>} />
          <Route path="/listar-jogos/" element={<ListarJogosPage/>} />
          <Route path="/editar-jogo/:jogoId" element={<EditarJogoPage/>} />
          <Route path="/jogos/:jogoId/detalhes" element={<EditarJogoDetalhes />} />
          <Route path="/classificacao" element={<ClassificacaoPage />} />
          <Route path="/classificacaoView" element={<ClassificacaoPageView />} />

          <Route path="/artilheiro" element={<ClassificacaoJogadoresView />} />
          <Route path="/classificacao/jogadores" element={<ClassificacaoJogadores />} />

          <Route path="/jogos" element={<ListarJogosPageView />} />
          <Route path="/melhorJogadorVoto" element={<VotarMelhorJogadorPage />} />
          <Route path="/melhorJogador" element={<MelhorJogadorPage />} />
          
          


          {/* Rotas privadas (requerem autenticação) */}
          <Route path="/votacao" element={<AuthMiddleware><VotacaoPotes /></AuthMiddleware>} />
          <Route path="/user/aprovacao" element={<AuthMiddlewareAdmin><PageAprove /></AuthMiddlewareAdmin>}/>
          <Route path="/painel" element={<AuthMiddleware><PeladaPanel /></AuthMiddleware>} />
          <Route path="/torneio/painel" element={<AuthMiddleware><PageDashBoard /></AuthMiddleware>} />
          <Route path="/avaliacao" element={<AuthMiddleware permitirGoleiro><AvaliacaoPage /></AuthMiddleware>} />
          <Route path="/avaliacao/:peladaId" element={<AuthMiddleware permitirGoleiro><AvaliacaoPage /></AuthMiddleware>} />
          <Route path="/ordem-chegada/" element={<AuthMiddleware><PlayArrivedPage /></AuthMiddleware>} />
          <Route path="/partidas" element={<AuthMiddleware><PartidasPage /></AuthMiddleware>} />
          <Route path="/checkin/nfc/:codigo" element={<AuthMiddleware><CheckinNfcPage /></AuthMiddleware>} />
          <Route path="/confirmarInscricao/" element={<AuthMiddleware><PageInscricao /></AuthMiddleware>} />
          <Route path="/pagamentoInscricao/" element={<AuthMiddleware><PageQrCode /></AuthMiddleware>} />
          <Route path="/perfil" element={<AuthMiddleware><ProfilePage /></AuthMiddleware>} />
          <Route path="/financeiro" element={<AuthMiddleware><FinanceiroPage /></AuthMiddleware>} />
          <Route path="/notificacoes" element={<AuthMiddleware><NotificacoesPage /></AuthMiddleware>} />
          <Route path="/peladas" element={<AuthMiddlewareAdmin><PeladasPage /></AuthMiddlewareAdmin>} />
          <Route path="/usuarios/novo" element={<AuthMiddlewareAdmin><CadastrarUsuarioPage /></AuthMiddlewareAdmin>} />
          <Route path="/peladas/:peladaId" element={<AuthMiddlewareAdmin><PeladaEstatisticasPage /></AuthMiddlewareAdmin>} />
          <Route path="/adminJogadores" element={<AuthMiddlewareAdmin><AdminPlayersPage /></AuthMiddlewareAdmin>} />
            
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
